import {createFeatureSelector, createSelector} from '@ngrx/store';
import * as fromErrorHandling from './error-handling.reducer';

export const selectErrorHandlingState =
  createFeatureSelector<fromErrorHandling.ErrorState>(
    fromErrorHandling.errorHandlingFeatureKey,
  );

export const selectUncaughtError = createSelector(
  selectErrorHandlingState,
  fromErrorHandling.getUncaughtError,
);

export const selectErrors = createSelector(
  selectErrorHandlingState,
  fromErrorHandling.getErrors,
);
